import React from "react";
import {
  AppstoreOutlined,
  DatabaseOutlined,
  FilterOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { MapWorkspacePanelContent } from "./FmMapWorkspacePanelRegistry";
import type {
  FmMapBasemapDescriptor,
  FmMapFilterValues,
  FmMapWorkspaceDescriptor,
  FmMapLayerId,
} from "./FmMapWorkspaceRoot.types";
import type { FmMapEmitFilter } from "./useMapWorkspaceFilters";
import type { PanelEntry } from "@/contexts/FmContextPanelContext";

const PANEL_ICONS = {
  legend: <AppstoreOutlined />,
  filters: <FilterOutlined />,
  collection: <DatabaseOutlined />,
  section: <InfoCircleOutlined />,
} as const;

export function useRegisteredMapWorkspacePanels(
  descriptor: FmMapWorkspaceDescriptor,
  emitFilter: FmMapEmitFilter,
  filterValues: FmMapFilterValues,
  controls: {
    toggleLayer: (layerId: FmMapLayerId, enabled: boolean) => void;
    selectBaseMap: (baseMapId: FmMapBasemapDescriptor["id"]) => void;
  },
): PanelEntry[] {
  const { selectBaseMap, toggleLayer } = controls;
  const {
    activeBaseMapId,
    baseMaps,
    filters,
    layers,
    onEvent,
    panels,
  } = descriptor;
  return React.useMemo(
    () =>
      panels.map((panel) => ({
        key: panel.id,
        icon: PANEL_ICONS[panel.kind],
        tooltip: panel.title,
        visibleInMapTools: true,
        content: (
          <MapWorkspacePanelContent
            activeBaseMapId={activeBaseMapId}
            baseMaps={baseMaps}
            emitFilter={emitFilter}
            filterValues={filterValues}
            filters={filters}
            layers={layers}
            onEvent={onEvent}
            panel={panel}
            toggleLayer={toggleLayer}
            selectBaseMap={selectBaseMap}
          />
        ),
      })),
    [
      activeBaseMapId,
      baseMaps,
      emitFilter,
      filterValues,
      filters,
      layers,
      onEvent,
      panels,
      selectBaseMap,
      toggleLayer,
    ],
  );
}
